import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import ValueLink from 'sb-valuelink'
import actions from 'redux/actions'
import { constants, formatPrice, mixpanel, snowplow } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import HintForPremium from 'components/product/HintForPremium/HintForPremium'
import UpchargePrice from 'components/UpchargePrice/UpchargePrice'
import CommonButton from 'components/buttons/CommonButton/CommonButton'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'
import CheckBox from 'components/forms/CheckBox/CheckBox'
import Modal from 'components/modal/Modal/Modal'
import Image from 'components/ui/Image/Image'
import Link from 'components/ui/Link/Link'

import messages from './messages'
import s from './AddedProductModal.scss'


class AddedProductModal extends PureComponent {

  static propTypes = {
    data: PropTypes.shape({
      isFreeMonth: PropTypes.bool.isRequired,
      item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        image: PropTypes.string.isRequired,
        index: PropTypes.number.isRequired,
        upchargePrice: PropTypes.number.isRequired,
        brand: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        typeGroup: PropTypes.string,
      }).isRequired,
      onClose: PropTypes.func.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    name: constants.modals.premiumProducts.AddedProduct,
  }

  state = {
    shouldTrackEvent: false,
    dontShowAgain: false,
  }

  handleCheckBoxClick = (value) => {
    const { name } = this.props

    const action = value
      ? actions.models.ui.setClosedPopup
      : actions.models.ui.resetClosedPopup

    action(name)
      .finally(() => this.setState({ shouldTrackEvent: value }))
  }

  handleSubTextClick = () => {
    const { data: { item: { id, index, brand, name } } } = this.props

    actions.models.queue.removeItem({
      id,
      index,
      page: 'premium product popup',
      metadata: {
        placement: 'premium product popup',
        brand,
        name,
      },
    })

    snowplow.track(constants.snowplowEvents.optOutPremiumPopup, {}, false)

    this.close(true)
  }

  handleCloseWithoutRemove = () => {
    this.close(false)
  }

  close = (itemWasRemoved = false) => {
    const { shouldTrackEvent } = this.state
    const { name, data: { onClose } } = this.props

    actions.models.modals.close(name)

    if (shouldTrackEvent) {
      mixpanel.track(constants.analyticsEvents.premiumProducts.optOutPremiumPopup)
    }

    if (typeof onClose === 'function') {
      onClose(itemWasRemoved)
    }
  }

  render() {
    const { name, data: { item, isFreeMonth } } = this.props

    const valueLink = ValueLink.state(this, 'dontShowAgain')

    // TODO replace with "image"
    const { img, image, upchargePrice = 1000, typeGroup } = item
    const price = formatPrice(upchargePrice, true)

    return (
      <Modal
        name={name}
        title={messages.title}
        titleUppercase
        buttonTitle={messages.buttonTitle}
        onClose={this.handleCloseWithoutRemove}
      >
        <div className={s.imageContainer}>
          <UpchargePrice className={s.priceLabel} price={upchargePrice} large />
          <Image className={s.image} src={image || img} h={300} mH={200} />
        </div>
        {
          isFreeMonth ? (
            <FormattedMessage className={s.freeMonthTitle} tag="div" {...messages.forFreeMonth} values={{ price }} />
          ) : (
            <FormattedMessage className={s.title} tag="div" {...messages.additionalPrice} values={{ price }} />
          )
        }
        <HintForPremium typeGroup={typeGroup} placement="add to queue popup" />
        <div className={s.checkboxContainer}>
          <CheckBox
            label={messages.checkboxLabel}
            valueLink={valueLink.onChange((value) => this.handleCheckBoxClick(value))}
          />
        </div>
        <ModalFooter>
          <CommonButton className={s.button} brand lg gotIt onClick={this.handleCloseWithoutRemove} />
          <br />
          <Link
            className={s.subText}
            title={messages.subText}
            grayColor
            onClick={this.handleSubTextClick}
          />
        </ModalFooter>
      </Modal>
    )
  }
}


export default AddedProductModal
